import { ThemeComponentType } from '../types';

export const NativeSelect: ThemeComponentType = {
  defaultProps: {
    p: 'lg',
    shadow: 'xs',
  },
  styles: (theme, variant) => ({
    input: {
      paddingTop: 0,
      paddingBottom: 0,

      '&&:read-only': {
        cursor: 'default',
        background: 'white',
      },
    },
  }),
};
